module.exports = __webpack_public_path__ + "img/paper.77e297f2.svg";